import React from 'react';
import { Heart } from 'lucide-react';
export function ClosingSection() {
  return <section className="py-16 bg-stone-100 text-center border-t border-stone-200" data-id="element-58">
      <div className="max-w-2xl mx-auto px-4" data-id="element-59">
        <div className="flex justify-center mb-6" data-id="element-60">
          <Heart className="text-red-400 w-8 h-8 fill-red-100" data-id="element-61" />
        </div>

        <p className="text-xl font-serif italic text-gray-800 mb-4" data-id="element-62">
          "No todo momento incómodo es una crisis. A veces es una señal."
        </p>

        <p className="text-lg text-gray-600" data-id="element-63">
          Este libro no te empuja hacia adelante. Te ayuda a volver a vos.
        </p>

        <div className="mt-12 text-sm text-gray-400" data-id="element-64">
          <p data-id="element-65">
            © {new Date().getFullYear()} Esto no es una crisis. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </section>;
}